import React, { useRef }from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Features from '../components/features'
import Practice from '../components/practice'
import Doctor from '../components/doctor'
import './home.css'

const Home = (props) => {
  const videoRef = useRef(null);

  const handleVideoClick = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };
  
  return (
    <div className="home-container">
      <Helmet>
        <title>Medica template</title>
        <meta property="og:title" content="Medica template" />
      </Helmet>
      <div data-modal="practices" className="home-modal">
        <div className="home-practices">
          <div className="home-heading">
            <span className="home-header">Our practices</span>
            <svg
              viewBox="0 0 1024 1024"
              data-close="practices"
              className="home-close"
            >
              <path d="M225.835 286.165l225.835 225.835-225.835 225.835c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l225.835-225.835 225.835 225.835c16.683 16.683 43.691 16.683 60.331 0s16.683-43.691 0-60.331l-225.835-225.835 225.835-225.835c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0l-225.835 225.835-225.835-225.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331z"></path>
            </svg>
          </div>
          <div className="home-grid">
            <div className="home-section">
              <div className="home-heading01">
                <span className="home-header01">Cardiology</span>
                <span className="home-caption">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <a className="home-text" href="/References/JSIP20120300010_94521693.pdf" download>Read more</a>
                <img
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image"
                />
              </div>
            </div>
            <div className="home-section01">
              <div className="home-heading02">
                <span className="home-header02">Orthopedics</span>
                <span className="home-caption1">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text01">Read more</span>
                <img
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image01"
                />
              </div>
            </div>
            <div className="home-section02">
              <div className="home-heading03">
                <span className="home-header03">Ophtalmology</span>
                <span className="home-caption2">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text02">Read more</span>
                <img
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image02"
                />
              </div>
            </div>
            <div className="home-section03">
              <div className="home-heading04">
                <span className="home-header04">Pediatrics</span>
                <span className="home-caption3">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text03">Read more</span>
                <img
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image03"
                />
              </div>
            </div>
            <div className="home-section04">
              <div className="home-heading05">
                <span className="home-header05">Nutrition</span>
                <span className="home-caption4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text04">Read more</span>
                <img
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image04"
                />
              </div>
            </div>
            <div className="home-section05">
              <div className="home-heading06">
                <span className="home-header06">General</span>
                <span className="home-caption5">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </span>
              </div>
              <div className="read-more">
                <span className="home-text05">Read more</span>
                <img
                  alt="image"
                  src="/Icons/arrow-2.svg"
                  className="home-image05"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="home-hero">
        <header data-thq="thq-navbar" className="home-navbar">
          <div className="home-left">
            <img
              alt="image"
              src="/logo_fing_horizontal_rgb-200h.jpg"
              loading="eager"
              className="home-logo"
            />
            <nav className="home-links">
              <a href="#features" className="home-link">
                Introduccion
              </a>
              <a href="#how-it-works" className="home-link1">
                Descripcion
              </a>
              <span className="home-link2">Caracteristicas</span>
              <a href="#schedule" className="home-link3">
                Resultados
              </a>
            </nav>
          </div>
          <div data-thq="thq-navbar-btn-group" className="home-right">
            <a
              href="https://gitlab.fing.edu.uy/karime.villanueva/timage"
              target="_blank"
              rel="noreferrer noopener"
              className="home-book button button-main"
            >
              <svg viewBox="0 0 1024 1024" className="home-icon1">
                <path d="M59.429 403.429l452.571 580-496-360c-13.714-10.286-19.429-28-14.286-44l57.714-176zM323.429 403.429h377.143l-188.571 580zM210.286 53.714l113.143 349.714h-264l113.143-349.714c6.286-17.714 31.429-17.714 37.714 0zM964.571 403.429l57.714 176c5.143 16-0.571 33.714-14.286 44l-496 360 452.571-580zM964.571 403.429h-264l113.143-349.714c6.286-17.714 31.429-17.714 37.714 0z"></path>
              </svg>
              <span className="home-text06">  Go to GitHub</span>
            </a>
          </div>
          <div data-thq="thq-burger-menu" className="home-burger-menu">
            <svg viewBox="0 0 1024 1024" className="home-icon3">
              <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
            </svg>
          </div>
          <div data-thq="thq-mobile-menu" className="home-mobile-menu">
            <div
              data-thq="thq-mobile-menu-nav"
              data-role="Nav"
              className="home-nav"
            >
              <div className="home-container1">
                <img
                  alt="image"
                  src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                  className="home-image06"
                />
                <div data-thq="thq-close-menu" className="home-menu-close">
                  <svg viewBox="0 0 1024 1024" className="home-icon5">
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              <nav
                data-thq="thq-mobile-menu-nav-links"
                data-role="Nav"
                className="home-nav1"
              >
                <span className="home-text07">Features</span>
                <span className="home-text08">How it works</span>
                <span className="home-text09">Prices</span>
                <span className="home-text10">Contact</span>
                <button className="home-book1 button button-main">
                  <img
                    alt="image"
                    src="/Icons/calendar.svg"
                    className="home-image07"
                  />
                  <span className="home-text11">Book an appointment</span>
                </button>
              </nav>
            </div>
          </div>
        </header>
        <div className="home-main">
          <div className="home-content">
            <div className="home-heading07">
              <h1 className="home-header07">
                <span>
                  Reconocimiento  de Lenguaje de Señas
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>Sign Language Recognition</span>
                <br></br>
              </h1>
              <p className="home-caption6">
                <span>Tratamiento de Imágenes por Computadora</span>
                <br></br>
                <span> MCDAA 2023</span>
                <br></br>
              </p>
            </div>
          </div>
          <div className="home-image08">
            <img
              alt="image"
              src="https://images.unsplash.com/photo-1617069897015-7d27a76232ed?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDR8fGhhbmR8ZW58MHx8fHwxNjg5Mjc5NjkzfDA&amp;ixlib=rb-4.0.3&amp;w=500"
              className="home-image09"
            />
          </div>
        </div>
        <div id="features" className="home-features">
          <div className="home-content01">
            <Features
              Title="Segmentacion"
              Description="Primera etapa del reconocimiento de la seña es reconocer correctamente la mano"
            ></Features>
            <Features
              Title="Caracteristicas"
              Description="Una vez definida la mano se debe identificar que caracteristicas diferencias una mano de otra"
            ></Features>
            <Features
              Title="Clasificacion"
              Description="Dadas distintas tecnicas de clasificacion evaluar cual es la que obtiene mejores resultados"
            ></Features>
          </div>
        </div>
        <div className="home-background"></div>
      </section>
      <section className="home-practices1">
        <div className="home-heading08">
          <h2 className="home-text20">
            <span className="home-text21">Articulos</span>
            <br></br>
            <span> relacionados</span>
            <br></br>
          </h2>
          <p className="home-text25">
            Artículos relacionados con estudios sobre  SLR utilizando distintos
            mecanismos de detección y procesamiento de imágenes.
          </p>
        </div>
        <div className="home-content02">
          <div className="home-grid1">
            <Link to="/">
              <div className="home-practice-wrapper">
                <Practice></Practice>
              </div>
            </Link>
            <Link to="/">
              <div className="home-practice-wrapper1">
                <Practice
                  Title="Data Glove with Bending Sensor and Inertial Sensor Based on Weighted DTW Fusion for Sign Language Recognition"
                  Description="Comparacion de señas dinamicas utilizando Dynamic Time Warping (DTW)"
                ></Practice>
              </div>
            </Link>
            <Link to="/">
              <div className="home-practice-wrapper2">
                <Practice
                  Title="Estudio comparativo de algoritmos de segmentacio ́n de piel usando atributos de color"
                  Description="Comparacion de segmentacion de piel mediante tres metodos, algoritmo basado en redes neuronales, Naive Bayes y umbralizacion."
                ></Practice>
              </div>
            </Link>
            <Link to="/">
              <div className="home-practice-wrapper3">
                <Practice
                  Title="Traduccion del lenguaje de señas usando vision por computadora"
                  Description="Comparacion de tres metodos, Momentos de Hu, Momentos de Zernike e Histogramas de orientacion del gradiente (HOG)."
                ></Practice>
              </div>
            </Link>
            <Link to="/">
              <div className="home-practice-wrapper4">
                <Practice
                  Title="An algorithm on sign words extraction and recognition of continuous Persian sign language based on motion and shape features of hands"
                  Description="Busca clasificar la lengua de señas persa a partir de su propia base de datos, utilizando modelos ocultos de Markov y un algoritmo híbrido KNN-DTW"
                ></Practice>
              </div>
            </Link>
            <Link to="/">
              <div className="home-practice-wrapper5">
                <Practice
                  Title="Sign Language Recognition - Franco Ronchetti"
                  Description="Base de datos LSA con métodos de reconocimiento, análisis y herramientas."
                ></Practice>
              </div>
            </Link>
          </div>
        </div>
      </section>
      <section id="how-it-works" className="home-why">
        <div className="home-heading09">
          <h2 className="home-header08">Introducción</h2>
          <p className="home-header09">
            <br></br>
            <span>
              El lenguaje de señas es una forma de comunicación visual que
              emplea gestos y es principalmente utilizada por las personas
              sordas para expresarse.
            </span>
            <br></br>
            <span>
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <br></br>
            <span>
              Este proyecto es desarrollado en el marco de la materia
              Tratamiento de Imágenes por Computadora 2023, de la Facultad de
              Ingeniería se utilizaran métodos de segmentación y clasificación
              de manos de un conjunto acotado de señas. Además, el proyecto se
              basará en técnicas tradicionales de procesamiento de imágenes para
              detectar y clasificar los gestos de las manos.
            </span>
            <br></br>
          </p>
        </div>
        <div className="home-content03">
          <div className="home-video">
            <video
              src="/Video-villanueva.mp4"
              className="home-video1"
              ref={videoRef}
              onClick={handleVideoClick}
            ></video>
          </div>
          <div className="home-caption7">
            <h3 className="home-header10">Limitaciones del proyecto</h3>
            <p className="home-header11">
              <span>
                Las señas pueden ser señas estáticos o dinámicos dependiendo del
                significado, dada la complejidad, se limita el problema a señas 
              </span>
              <span>
                {' '}
                estáticas que suelen utilizarse para representar objetos,
                personas o conceptos estáticos. Por ejemplo r
              </span>
              <span>epresentación de animales, n</span>
              <span>úmeros, colores, letras, etc.</span>
              <br></br>
            </p>
          </div>
        </div>
      </section>
      <section className="home-features1">
        <div className="home-section06">
          <div className="home-content04">
            <div className="home-header12">
              <h2 className="home-heading10">Diferencias entre países</h2>
              <p className="home-capton">
                <span>
                  Al igual que los idiomas hablados, los lenguajes de señas
                  pueden variar de un país a otro y pueden deberse a diferencias
                  gramaticales, culturales, etc. Las señas estáticas y dinámicas
                  también pueden diferir en su forma y uso en diferentes países.
                </span>
                <br></br>
                <br></br>
                <span>
                  {' '}
                  Estas variaciones pueden estar influenciadas por la cultura,
                  la historia, incluso por las deformaciones en el tiempo. Por
                  ejemplo, la palabra más simple “Hola” difiere según el idioma.
                </span>
                <br></br>
                <br></br>
                <span>
                  Se han establecido estándares internacionales que facilitan la
                  comunicación y el aprendizaje de diferentes lenguajes de
                  señas, como por ejemplo la Lengua de Signos Española (LSE) que
                  estandariza los signos utilizados en el lenguaje español.
                </span>
                <br></br>
              </p>
            </div>
            <div className="home-more6 read-more"></div>
          </div>
          <img
            alt="image"
            src="/screenshot%202023-07-13%20at%2020.08.30-1500w.png"
            className="home-image11"
          />
        </div>
        <div className="home-section07">
          <img
            alt="image"
            src="/screenshot%202023-07-20%20at%2001.50.22-200w.png"
            className="home-image12"
          />
          <div className="home-content05">
            <div className="home-header13">
              <h2 className="home-heading11">Bases de datos y segmentación</h2>
              <p className="home-capton1">
                Se obtienen variadas bases de datos de los articulos mencionados
                y referencias, que presentan distintas dificultades al momento
                de segmentar la mano, la lectura mas sencilla es la mano
                diferenciada por un guante de color y fondo negro, de forma
                facilmente distinguible, otra alternativa es la mano sin guante
                sobre fondo uniforme, distinto al color de la mano, y por ultimo
                y con mas dificultad es reconocer la mano sobre fondos variados
                que pueden contener brazo cara o otras partes del cuerpo o
                objetos con rangos de color similares.
              </p>
            </div>
          </div>
          <img alt="image" src="/mano-1500w.png" className="home-image13" />
        </div>
        <div className="home-section08">
          <div>
            <Script
              html={`<!DOCTYPE html>
<html>
<head>
  <style>
    pre {
      background-color: #f4f4f4;
      padding: 10px;
      font-family: Consolas, monospace;
      line-height: 1.5;
      font-size: 16px;
      border-radius: 5px;
    }
  </style>
</head>
<body>
  <pre>
    <code>
def segmentar_manos_red(img):
    img_gray = cv2.cvtColor(img, cv2.COLOR_BGR2GRAY)
    _, binary_mask = cv2.threshold(img_gray, 1, 255, cv2.THRESH_BINARY)
    binary_mask_inv = cv2.bitwise_not(binary_mask)
    white_result = cv2.bitwise_and(img, img, mask=binary_mask_inv)
    white_result[binary_mask_inv == 0] = [255, 255, 255]

    return white_result

input_dir = "lsa16/lsa16_images/black_and_red/"

# Obtener la lista de archivos en el directorio de entrada
files = os.listdir(input_dir)

for file in files:
    # Leer la imagen de entrada
    image_path = os.path.join(input_dir, file)
    imagen = cv2.imread(image_path)

    # Segmentar la imagen en manos
    # HSV_result, YCrCb_result, global_result = segmentar_manos_piel(imagen)
    manos_rojas = segmentar_manos_red(imagen)

    manos_rojas_path = os.path.join("Red_result/" + file)
    cv2.imwrite(manos_rojas_path, manos_rojas)
    </code>
  </pre>
</body>
</html>
`}
            ></Script>
          </div>
        </div>
        <div className="home-section09"></div>
        <div className="home-section10">
          <div className="home-content06">
            <div className="home-header14">
              <h2 className="home-heading12">Características de las manos</h2>
              <p className="home-capton2">
                Los artículos relacionados poseen una serie de caracteristicas
                para clasificar manos como por ejemplo los momentos Hu, SIFT,
                momentos de Zernike, etc. Dado que la informacion del contorno
                es diferente para cada posicion de la mano se agregan algunas
                caracteristicas que podrían ser importantes como el area,
                perimetro, convexidad, cantidad de picos y curvatura de Fourier.
              </p>
            </div>
          </div>
          <img
            alt="image"
            src="/screenshot%202023-07-20%20at%2018.24.07-1500w.png"
            className="home-image14"
          />
        </div>
        <div>
          <Script
            html={`<!DOCTYPE html>
<html>
<head>
  <style>
    pre {
      background-color: #f4f4f4;
      padding: 10px;
      font-family: Consolas, monospace;
      line-height: 1.5;
      font-size: 16px;
      border-radius: 5px;
    }
  </style>
</head>
<body>
  <pre>
    <code>
def calcular_perimetro(img):
    contornos, _ = cv2.findContours(img, cv2.RETR_EXTERNAL, cv2.CHAIN_APPROX_SIMPLE)
    hand_contour = max(contornos, key=cv2.contourArea)
    perimetro = cv2.arcLength(hand_contour, True)

    return perimetro

def detect_border (img):
    block_size = 2  # Tamaño del vecindario para el cálculo de la matriz de covarianza
    aperture_size = 3  # Tamaño de la apertura del operador Sobel
    k = 0.04  # Parámetro de sensibilidad

    # Aplicar el detector de esquinas Harris
    esquinas = cv2.cornerHarris(img, block_size, aperture_size, k)

    esquinas_norm = cv2.normalize(esquinas, None, alpha=0, beta=255, norm_type=cv2.NORM_MINMAX, dtype=cv2.CV_8U)
    umbral = 100  # Ajusta este valor según tus necesidades
    esquinas_destacadas = esquinas_norm > umbral

    return esquinas_destacadas

def calcular_momentos_hu(imagen):
    momentos = cv2.moments(imagen)
    momentos_hu = cv2.HuMoments(momentos)

    momentos_hu = -np.sign(momentos_hu) * np.log10(np.abs(momentos_hu))
    momentos_hu_normalized = cv2.normalize(momentos_hu, None, alpha=0, beta=1, norm_type=cv2.NORM_MINMAX, dtype=cv2.CV_32F)

    return momentos_hu_normalized

def calcular_convexidad(image):
    contours, _ = cv2.findContours(image, cv2.RETR_EXTERNAL, cv2.CHAIN_APPROX_SIMPLE)
    hand_contour = max(contours, key=cv2.contourArea)
    hull = cv2.convexHull(hand_contour)
    hull_area = cv2.contourArea(hull)
    contour_area = cv2.contourArea(hand_contour)
    convexity = contour_area / hull_area

    return convexity

def calcular_descriptores_curvatura_fourier(image, num_descriptores):
    contours, _ = cv2.findContours(image, cv2.RETR_EXTERNAL, cv2.CHAIN_APPROX_SIMPLE)
    hand_contour = max(contours, key=cv2.contourArea)
    x = hand_contour[:, 0, 0]
    y = hand_contour[:, 0, 1]
    dx_dt = np.gradient(x)
    dy_dt = np.gradient(y)
    d2x_dt2 = np.gradient(dx_dt)
    d2y_dt2 = np.gradient(dy_dt)
    curvatura = (dx_dt * d2y_dt2 - dy_dt * d2x_dt2) / np.power(dx_dt**2 + dy_dt**2, 1.5)

    transformada_fourier = fft.fft(curvatura)
    coeficientes_significativos = np.abs(transformada_fourier[:num_descriptores])
    coeficientes_normalizados = coeficientes_significativos / np.sum(coeficientes_significativos)

    return coeficientes_normalizados
    </code>
  </pre>
</body>
</html>
`}
          ></Script>
        </div>
      </section>
      <section id="schedule" className="home-schedule">
        <div className="home-content07">
          <div className="home-header15">
            <h2 className="home-heading13">Resultados y conclusiones</h2>
            <p className="home-caption8">
              Se presentan a continuacion las distintas pruebas realizadas para
              entrenar y predecir la seña correspondiente, tener en cuenta que
              las bases de datos son balanceadas.
            </p>
          </div>
          <div className="home-types">
            <button className="home-book-person button button-main button-white">
              <span>          Base de datos LSA          </span>
            </button>
            <button className="button button-main button-white home-book-person1">
              <span>Base de datos fondo color </span>
            </button>
          </div>
        </div>
      </section>
      <div className="home-search">
        <div className="home-content08">
          <div className="home-type-one">
            <h3 className="home-text48">Analisis grafico de descriptores</h3>
            <p className="home-text49">
              <span>
                Se utilizan los descriptores &apos;Area&apos;,
                &apos;Picos&apos;, &apos;Perimetro&apos;, &apos;Hu1&apos;,
                &apos;Hu2&apos;,&apos;Hu3&apos;,
                &apos;Hu4&apos;,&apos;Hu5&apos;, &apos;Hu6&apos;,
                &apos;Hu7&apos;, &apos;Convexidad&apos;,
                &apos;Fourier1&apos;,&apos;Fourier2&apos;,&apos;Fourier3&apos;,&apos;Fourier4&apos;, 
                los cuales 
              </span>
              <span>
                en primer lugar se agrupan en el array data para graficar su
                dispersión y evaluar si un par de descriptores son suficientes
                para distinguir entre las 16 clases.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </p>
            <div data-teleport="results" className="home-results">
              <span className="home-heading14">Results:</span>
              <div data-results="letters" className="home-list"></div>
            </div>
            <div className="home-div2">
              <Script
                html={`<!DOCTYPE html>
<html>
<head>
  <style>
    pre {
      background-color: #f4f4f4;
      padding: 10px;
      font-family: Consolas, monospace;
      line-height: 1.5;
      font-size: 16px;
      border-radius: 5px;
    }
  </style>
</head>
<body>
  <pre>
    <code>
vars=['Area', 'Picos', 'Perimetro', 'Hu1', 'Hu2','Hu3', 'Hu4','Hu5', 'Hu6', 'Hu7',
   'Convexidad', 'Fourier1','Fourier2','Fourier3','Fourier4']
data = pd.DataFrame(columns= vars)

clases = ['{:02d}'.format(i) for i in range(1, 17)]
files = os.listdir("Red_result")
imagenes = [[] for _ in range(16)]

# Iterar sobre las imágenes y calcular los descriptores
for file in files:
    imagen = cv2.imread("Red_result/" + file)

    area = np.sum(imagen > 0)

    img_proc = cv2.cvtColor(imagen, cv2.COLOR_BGR2GRAY)
    picos = detect_border(img_proc)
    perimetro = calcular_perimetro(img_proc)
    hu_moments = calcular_momentos_hu(img_proc)
    convexidad = calcular_convexidad(img_proc)
    fourier = calcular_descriptores_curvatura_fourier(img_proc,4)
    
    descriptor = {
        'Area': area,
        'Picos': np.sum(picos),
        'Perimetro': perimetro,
        'Hu1': hu_moments[0],
        'Hu2': hu_moments[1],
        'Hu3': hu_moments[2],
        'Hu4': hu_moments[3],
        'Hu5': hu_moments[4],
        'Hu6': hu_moments[5],
        'Hu7': hu_moments[6],
        'Convexidad': convexidad,
        'Fourier1': fourier[0],
        'Fourier2': fourier[1],
        'Fourier3': fourier[2],
        'Fourier4': fourier[3],
        'Clase': file[:2],
        }
    
    aux = pd.DataFrame(descriptor, index=[0])
    data = pd.concat([data, aux], ignore_index=True)
    imagenes[int(file[:2])-1].append([convexidad,hu_moments[3]])

sns.pairplot(data, vars=vars, hue='Clase')
    </code>
  </pre>
</body>
</html>
`}
              ></Script>
            </div>
            <p className="home-text52">
              Dados los resultados, se puede apreciar que no hay ningún par
              distinga completamente las clases pero para testearlo se eligen la
              convexidad y el momento nro 4 de Hu para entrenar el modelo.
            </p>
            <img
              alt="image"
              src="/plot2.png"
              className="home-image15"
            />
          </div>
          <h3 className="home-text53">Entrenamiento de modelos</h3>
          <div className="home-type-two">
            <div className="home-heading15">
              <p className="home-text54">
                Teniendo en cuenta que dos descriptores no son suficientes se
                decide utilizar PCA y probar distintos valores para llegar al
                máximo posible, el cual se da en 11 componentes.
              </p>
            </div>
          </div>
          <div className="home-div3">
            <Script
              html={`<!DOCTYPE html>
<html>
<head>
  <style>
    pre {
      background-color: #f4f4f4;
      padding: 10px;
      font-family: Consolas, monospace;
      line-height: 1.5;
      font-size: 16px;
      border-radius: 5px;
    }
  </style>
</head>
<body>
  <pre>
    <code>

X = data.drop(columns=['Clase'])
y = data['Clase']

nan_count_by_column = X.isna().sum()
print(nan_count_by_column[nan_count_by_column > 0])

# Hay once imagenes que tiene los datos de fourier con NaN para evitar erorres:
column_means = X.mean()
X = X.fillna(column_means)

# Dividir los datos en conjuntos de entrenamiento y prueba
trainX, testX, trainY, testY = train_test_split(X, y, test_size=0.33, random_state=42, stratify= y)

# Crear el pipeline
pipeline = Pipeline([
    ('scaler', StandardScaler()),
    ('pca', PCA(n_components=11)),
    ('knn', KNeighborsClassifier(n_neighbors=3))
])

# Entrenar el modelo usando el pipeline
pipeline.fit(trainX, trainY)

# Predecir en el conjunto de prueba y calcular la tasa de aciertos
pred = pipeline.predict(testX)
accuracy = accuracy_score(testY, pred)
print("Tasa de aciertos:", accuracy)

# Mostrar la matriz de confusión
cm = confusion_matrix(testY, pred)
disp = ConfusionMatrixDisplay(confusion_matrix=cm)
disp.plot()
    </code>
  </pre>
</body>
</html>
`}
            ></Script>
          </div>
          <p className="home-text55">
            Luego utilizando la funcionalidad SelectKBest disponible en sklearn
            se verifican cuales son los mejores 8 descriptores para entrenar el
            modelo, los cuales son &apos;Area&apos;, &apos;Perimetro&apos;,
            &apos;Hu2&apos;, &apos;Hu4&apos;, &apos;Hu5&apos;, &apos;Hu6&apos;,
            &apos;Hu7&apos;, &apos;Convexidad&apos;, lo que es logico dado que
            varios valores de Fourier dan NaN.
          </p>
          <div className="home-div4">
            <Script
              html={`<!DOCTYPE html>
<html>
<head>
  <style>
    pre {
      background-color: #f4f4f4;
      padding: 10px;
      font-family: Consolas, monospace;
      line-height: 1.5;
      font-size: 16px;
      border-radius: 5px;
    }
  </style>
</head>
<body>
  <pre>
    <code>
selector = SelectKBest(score_func=f_classif, k=8)
selector.fit(X, y)

selected_features_mask = selector.get_support()

# Obtener los nombres de las características seleccionadas
selected_features = X.columns[selected_features_mask]

print("Las características seleccionadas son:")
print(selected_features)

# Dividir los datos en conjuntos de entrenamiento y prueba
trainX, testX, trainY, testY = train_test_split(X, y, test_size=0.33, random_state=42, stratify= y)

# Crear el pipeline
pipeline = Pipeline([
    ('scaler', StandardScaler()),
    ('select_best', SelectKBest(score_func=f_classif, k=8)),
    ('knn', KNeighborsClassifier(n_neighbors=3))
])

# Entrenar el modelo usando el pipeline
pipeline.fit(trainX, trainY)

# Predecir en el conjunto de prueba y calcular la tasa de aciertos
pred = pipeline.predict(testX)
accuracy = accuracy_score(testY, pred)
print("Tasa de aciertos:", accuracy)

# Mostrar la matriz de confusión
cm = confusion_matrix(testY, pred)
disp = ConfusionMatrixDisplay(confusion_matrix=cm)
disp.plot()
    </code>
  </pre>
</body>
</html>
`}
            ></Script>
          </div>
          <p className="home-text56">
            Tambien se prueba utilizar SIFT para la clasificacion
          </p>
          <div className="home-div5">
            <Script
              html={`<!DOCTYPE html>
<html>
<head>
  <style>
    pre {
      background-color: #f4f4f4;
      padding: 10px;
      font-family: Consolas, monospace;
      line-height: 1.5;
      font-size: 16px;
      border-radius: 5px;
    }
  </style>
</head>
<body>
  <pre>
    <code>
def extract_sift_features(image):
    sift = cv2.SIFT_create()
    _, des = sift.detectAndCompute(image, None)
    return des if des is not None else np.array([]).reshape(0, 128)


files = os.listdir("Red_result")
X = []
y = []

for file in files:
    imagen = cv2.imread("Red_result/" + file)
    X.append(imagen)
    y.append(int(file[:2]))
    
global_features = []
fixed_size = (100,100,3)
for image in X:
    fv_sift = extract_sift_features(image)
    global_feature = np.hstack([fv_sift])
    global_feature.resize(fixed_size)
    global_features.append(global_feature)

X_train = np.array(global_features)
X_train = X_train.reshape(len(X_train),100*100*3)
Y_train = np.array(y)
train_x, test_x, train_y, test_y = train_test_split(X_train, Y_train, 
                                                      test_size=0.33, 
                                                      stratify=Y_train, 
                                                      random_state=42)

knn = KNeighborsClassifier(n_neighbors=3)
knn.fit(train_x, train_y)

# Se usa la prediccion en el conjunto de test y 
#se calcula la tasa de aciertos y la matriz de confusion
pred = knn.predict(test_x)

accuracy = accuracy_score(test_y, pred)
print("Tasa de aciertos:", accuracy)

cm = confusion_matrix(test_y, pred)
disp = ConfusionMatrixDisplay(confusion_matrix=cm)
disp.plot()
    </code>
  </pre>
</body>
</html>
`}
            ></Script>
          </div>
        </div>
      </div>
      <section className="home-meet">
        <div className="home-heading16">
          <h2 className="home-text57">Resultados con LSA</h2>
          <p className="home-text58">
            A continuacion se presentan los resultados obtenidos sobre la base
            de datos LSA con las distintas tecnicas mencionadas anteriormente y
            un porcentaje de entrenamiento del 66%.
          </p>
        </div>
        <div className="home-list1">
          <div className="home-controls"></div>
          <div data-teleport="doctors" className="home-doctors">
            <Doctor 
              image_src="/Matriz/2desc-300w.png"
              text="Utilizando dos descriptores el porcentaje de aciertos es del 36%"
            ></Doctor>
            <Doctor
              image_src="/Matriz/pca-300w.png"
              heading="PCA"
              text="Utilizando PCA el porcentaje de aciertos es del 49%"
            ></Doctor>
            <Doctor
              image_src="/Matriz/selectk-300w.png"
              heading="Seleccion de 8 descriptores"
              text="Este metodo obtiene el 60% de aciertos"
            ></Doctor>
            <Doctor
              image_src="/Matriz/sift-300w.png"
              heading="SIFT"
              text="Este metodo tiene tasa de acierto del 38%"
            ></Doctor>
          </div>
        </div>
        <div className="home-search1"></div>
        <p className="home-text59">
          Se puede apreciar que la tasa de aciertos es baja en todos los casos
          esto se podria asociar a que la base de datos no tiene suficientes
          imagenes de entrenamiento por lo que se decide variar a solamente 10%
          de datos de test en la mejor configuracion posible, obteniendo asi
          mejores resultados, del 78%
        </p>
        <img
          alt="image"
          src="/Matriz/selectkmejor-1500w.png"
          className="home-image16"
        />
      </section>
      <section className="home-news">
        <div className="home-heading17">
          <h2 className="home-text60">Base de datos con fondo a color</h2>
          <p className="home-text61">
            Para contemplar casos mas complejos como por ejemplo que el color de
            fondo sea diferente de negro, se utiliza otra base de datos y a
            continuacion se presentan los resultados.
          </p>
        </div>
        <div className="home-heading17">
          <h3 className="home-text62">Segmentacion de manos</h3>
          <p className="home-text63">
            En este caso particular es necesario hacer la segmentacion de manos,
            dado que la imagen tiene varios tonos y sombras al igual que el
            fondo, se debe usar un espacio de color para segmentar la misma. Se
            prueba en primera instancia con los espacios de color YCrCb, HSV y
            la combinacion de ambos, obteniendo mejores resultados con el primer
            espacio.
          </p>
          <div className="home-list2">
            <div className="home-controls1"></div>
            <div data-teleport="doctors" className="home-doctors1">
              <Doctor
                image_src="/manos/06_10_01_0001-300w.png"
                heading="HSV"
              ></Doctor>
              <Doctor image_src="/manos/a_1-300w.jpg" heading="YCrCb"></Doctor>
              <Doctor
                image_src="/manos/06_10_01_000-300w.png"
                heading="Global"
              ></Doctor>
            </div>
          </div>
          <div data-teleport="results" className="home-results1">
            <span className="home-heading18">Results:</span>
            <div data-results="letters" className="home-list3"></div>
          </div>
          <div className="home-div6">
            <Script
              html={`<!DOCTYPE html>
<html>
<head>
  <style>
    pre {
      background-color: #f4f4f4;
      padding: 10px;
      font-family: Consolas, monospace;
      line-height: 1.5;
      font-size: 16px;
      border-radius: 5px;
    }
  </style>
</head>
<body>
  <pre>
    <code>
def segmentar_manos_piel(img):
    img_HSV = cv2.cvtColor(img, cv2.COLOR_BGR2HSV)
    # Rango de color de piel en el espacio de color HSV
    HSV_mask = cv2.inRange(img_HSV, (0, 15, 0), (17, 170, 255))
    HSV_mask = cv2.morphologyEx(HSV_mask, cv2.MORPH_OPEN, np.ones((3, 3), np.uint8))

    img_YCrCb = cv2.cvtColor(img, cv2.COLOR_BGR2YCrCb)
    # Rango de color de piel en el espacio de color YCrCb
    YCrCb_mask = cv2.inRange(img_YCrCb, (0, 135, 85), (255, 180, 135))
    YCrCb_mask = cv2.morphologyEx(YCrCb_mask, cv2.MORPH_OPEN, np.ones((3, 3), np.uint8))

    # Combinar las máscaras resultantes
    global_mask = cv2.bitwise_and(YCrCb_mask, HSV_mask)
    global_mask = cv2.medianBlur(global_mask, 3)
    global_mask = cv2.morphologyEx(global_mask, cv2.MORPH_OPEN, np.ones((4, 4), np.uint8))

    # Obtener los resultados segmentados en cada espacio de color
    HSV_result = cv2.bitwise_not(HSV_mask)
    YCrCb_result = cv2.bitwise_not(YCrCb_mask)
    global_result = cv2.bitwise_not(global_mask)

    return HSV_result, YCrCb_result, global_result

    </code>
  </pre>
</body>
</html>
`}
            ></Script>
          </div>
          <p className="home-text64">
            Utilizando la mejor configuaracion posible se entrena el modelo, es
            de esperar que la tasa de aciertos baje debido a que las manos no se
            reconocen a la perfeccion, pero al ser una base mas grande puede
            mejorar el entrenamiento, con lo que se obtuvo una tasa de aciertos
            del 52%.
          </p>
          <div className="home-div7">
            <Script
              html={`<!DOCTYPE html>
<html>
<head>
  <style>
    pre {
      background-color: #f4f4f4;
      padding: 10px;
      font-family: Consolas, monospace;
      line-height: 1.5;
      font-size: 16px;
      border-radius: 5px;
    }
  </style>
</head>
<body>
  <pre>
    <code>
vars=['Area', 'Picos', 'Perimetro', 'Hu1', 'Hu2','Hu3', 'Hu4','Hu5', 'Hu6', 'Hu7', 
'Convexidad', 'Fourier1','Fourier2','Fourier3','Fourier4']
data = pd.DataFrame(columns= vars)

clases = ['a','b','c','d','l','p','v','w']
files = os.listdir("YCrCb_result")

# Iterar sobre las imágenes y calcular los descriptores
for file in files:
    imagen = cv2.imread("YCrCb_result/" + file)

    area = np.sum(imagen > 0)

    img_proc = cv2.cvtColor(imagen, cv2.COLOR_BGR2GRAY)
    picos = detect_border(img_proc)
    perimetro = calcular_perimetro(img_proc)
    hu_moments = calcular_momentos_hu(img_proc)
    convexidad = calcular_convexidad(img_proc)
    fourier = calcular_descriptores_curvatura_fourier(img_proc,4)
    
    descriptor = {
        'Area': area,
        'Picos': np.sum(picos),
        'Perimetro': perimetro,
        'Hu1': hu_moments[0],
        'Hu2': hu_moments[1],
        'Hu3': hu_moments[2],
        'Hu4': hu_moments[3],
        'Hu5': hu_moments[4],
        'Hu6': hu_moments[5],
        'Hu7': hu_moments[6],
        'Convexidad': convexidad,
        'Fourier1': fourier[0],
        'Fourier2': fourier[1],
        'Fourier3': fourier[2],
        'Fourier4': fourier[3],
        'Clase': file[:1],
        }
    
    aux = pd.DataFrame(descriptor, index=[0])
    data = pd.concat([data, aux], ignore_index=True)

X = data.drop(columns=['Clase'])
y = data['Clase']

column_means = X.mean()
X = X.fillna(column_means)

trainX, testX, trainY, testY = train_test_split(X, y, test_size=0.1, random_state=42, stratify= y)

# Crear el pipeline
pipeline = Pipeline([
    ('scaler', StandardScaler()),
    ('select_best', SelectKBest(score_func=f_classif, k=8)),
    ('knn', KNeighborsClassifier(n_neighbors=3))
])

# Entrenar el modelo usando el pipeline
pipeline.fit(trainX, trainY)

# Predecir en el conjunto de prueba y calcular la tasa de aciertos
pred = pipeline.predict(testX)
accuracy = accuracy_score(testY, pred)
print("Tasa de aciertos:", accuracy)

# Mostrar la matriz de confusión
cm = confusion_matrix(testY, pred)
disp = ConfusionMatrixDisplay(confusion_matrix=cm)
disp.plot()
    </code>
  </pre>
</body>
</html>
`}
            ></Script>
          </div>
          <img
            alt="image"
            src="/Matriz/basecolor-1700w.png"
            className="home-image17"
          />
        </div>
        <div className="home-list4">
          <div className="home-item">
            <div className="home-image18">
              <p className="home-quick-description">Conclusiones</p>
            </div>
            <div className="home-content09">
              <div className="home-details">
                <p className="home-quick-description1">
                  -Las bases de datos deben ser lo suficientemente grandes para
                  que el entrenamiento sea bueno
                </p>
              </div>
            </div>
          </div>
          <div className="home-item1">
            <div className="home-image19"></div>
            <div className="home-content10">
              <div className="home-details1">
                <p className="home-quick-description2">
                  -Los metodos tradicionales pueden llegar a tasas altas de
                  acierto pero considerando limitaciones como imagenes estaticas
                </p>
              </div>
            </div>
          </div>
          <div className="home-item2">
            <div className="home-image20"></div>
            <div className="home-content11">
              <div className="home-details2">
                <p className="home-quick-description3">
                  -El problema de segmentacion de manos puede llegar a ser muy
                  complejo por lo que se utilizan simplificaciones como guantes
                  de color
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="home-download"></div>
      <div>
        <Script
          html={`<script>
const dataLetters = document.querySelectorAll("[data-letter]");
let activeLetters = [];
const maxResults = 6;

dataLetters.forEach(letter => {
  letter.addEventListener("click", function() {
    if (this.classList.contains("letter-active")) {
      this.classList.remove("letter-active");
      activeLetters = activeLetters.filter(a => a !== this.dataset.letter);
    } else {
      this.classList.add("letter-active");
      activeLetters.push(this.dataset.letter);
    }
    if (activeLetters.length == 0) {
      document.querySelector("[data-teleport='results']").style.display = "none";
      return;
    }
    showResults();
  });
});

const showResults = () => {
  fetch("https://raw.githubusercontent.com/Shivanshu-Gupta/web-scrapers/master/medical_ner/medicinenet-diseases.json")
    .then(response => response.json())
    .then(data => {
      const filteredData = data.filter(item => {
        const firstLetter = item.disease.charAt(0).toLowerCase();
        if (activeLetters.includes(firstLetter)) {
          return true;
        }
        return false;
      });

      document.querySelector("[data-teleport='results']").style.display = "flex";
      const resultsContainer = document.querySelector("[data-results='letters']");
      resultsContainer.innerHTML = "";

      let counter = 0;
      const diseaseGroups = {};
      const totalActiveLetters = activeLetters.length;

      filteredData.forEach(disease => {
        const firstLetter = disease.disease[0].toLowerCase();
        if (diseaseGroups[firstLetter]) {
          diseaseGroups[firstLetter].push(disease);
        } else {
          diseaseGroups[firstLetter] = [disease];
        }
      });

      Object.keys(diseaseGroups).sort().forEach((firstLetter, index) => {
        const diseasesForThisLetter = diseaseGroups[firstLetter];
        const diseasesToShow = diseasesForThisLetter.slice(0, Math.ceil(maxResults / totalActiveLetters));

        diseasesToShow.forEach(disease => {
          const resultContainer = document.createElement("div");
          resultContainer.classList.add("search-result");
          resultContainer.classList.add("invisible");
          resultContainer.style.animationDelay = \`\${counter * 0.25}s\`;

          const resultText = document.createElement("span");
          resultText.classList.add("result-text");
          resultText.textContent = disease.disease;

          resultContainer.appendChild(resultText);
          resultsContainer.appendChild(resultContainer);
          counter++;

          if (counter === maxResults) {
            const moreContainer = document.createElement("div");
            moreContainer.classList.add("search-result");
            moreContainer.classList.add("more-results");

            const moreText = document.createElement("span");
            moreText.classList.add("result-text");
            moreText.textContent = "More";

            moreContainer.appendChild(moreText);
            resultsContainer.appendChild(moreContainer);
            addedMoreContainer = true;
            return;
          }
        });
      });
    });
};
</script>
`}
        ></Script>
      </div>
      <div>
        <Script
          html={`<script>
function scroll(direction) {
  const doctorsDiv = document.querySelector('[data-teleport="doctors"]');
  const scrollAmount = 300;
  if (direction === 'previous') {
    doctorsDiv.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  } else if (direction === 'next') {
    doctorsDiv.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }
}

const buttons = document.querySelectorAll('[data-doctors]');
buttons.forEach(button => {
  button.addEventListener('click', () => {
    const direction = button.dataset.doctors;
    scroll(direction);
  });
});
</script>`}
        ></Script>
      </div>
    </div>
  )
}

export default Home
